/**
 * @generated SignedSource<<bf5bc1b1b8a84e03f9b63c0e4137e782>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type SitesFilterInput = {
  isActive?: ActiveRecords | null | undefined;
  schoolYearEndsBeforeOrOn?: any | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  userId?: string | null | undefined;
};
export type ReportHubGetStandardsBySitesQuery$variables = {
  sitesFilter?: SitesFilterInput | null | undefined;
};
export type ReportHubGetStandardsBySitesQuery$data = {
  readonly sites: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly standardState: {
        readonly id: string;
        readonly stateStandardName: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ReportHubGetStandardsBySitesQuery = {
  response: ReportHubGetStandardsBySitesQuery$data;
  variables: ReportHubGetStandardsBySitesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sitesFilter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sitesFilterInput",
        "variableName": "sitesFilter"
      }
    ],
    "concreteType": "SiteNodeConnection",
    "kind": "LinkedField",
    "name": "sites",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SiteNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StandardStateNode",
            "kind": "LinkedField",
            "name": "standardState",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stateStandardName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubGetStandardsBySitesQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportHubGetStandardsBySitesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "32562da01ecbd6e6e7b5639578a30abc",
    "id": null,
    "metadata": {},
    "name": "ReportHubGetStandardsBySitesQuery",
    "operationKind": "query",
    "text": "query ReportHubGetStandardsBySitesQuery(\n  $sitesFilter: SitesFilterInput\n) {\n  sites(sitesFilterInput: $sitesFilter) {\n    nodes {\n      id\n      name\n      standardState {\n        id\n        stateStandardName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38082e4f95a56a04c57d63657a87967f";

export default node;
